import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const AdvantagesSection = styled.section`
	width: 100%;
	padding-block: 64px;
	${media.tablet} {
		padding-top: 56px;
	}
	${media.mobile} {
		padding-block: 40px 47px;
	}
`;
